import { Component, OnInit } from '@angular/core';

import { getObjectiveEntrepreneurshipSelectors } from 'src/app/modules/objective/store/objective.selectors';
import { IObjectivesFormState } from 'src/app/modules/objective/store/objective.state';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { formatDate } from 'src/app/utils/format-date';
import { formatCurrency } from 'src/app/utils/format-currency';

@Component({
  selector: 'app-pdf-entrepreneurship',
  templateUrl: './pdf-entrepreneurship.component.html',
  styleUrls: ['./pdf-entrepreneurship.component.scss'],
})
export class PdfEntrepreneurshipComponent implements OnInit {


  dataStoreEntrepreneurship$: Observable<any>;
  dataStoreEntrepreneurship: IObjectivesFormState;
  intendDate: any;
  minInvestimentFormated: string;
  maxInvestimentFormated: string;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.getState();
  }
  getState() {
    this.dataStoreEntrepreneurship$ = this.store.select(
      getObjectiveEntrepreneurshipSelectors
    );
    this.dataStoreEntrepreneurship$.subscribe((value) => {
      this.dataStoreEntrepreneurship = {
        ...(this.dataStoreEntrepreneurship = value),
      };
    });

    this.intendDate = this.dataStoreEntrepreneurship.date;
    if (this.intendDate) {
      this.intendDate = formatDate(this.intendDate);
    } else {
      this.intendDate = 'data não especificada!';
    }

    this.minInvestimentFormated = formatCurrency(
      this.dataStoreEntrepreneurship.minimumInvestment
    );
    this.maxInvestimentFormated = formatCurrency(
      this.dataStoreEntrepreneurship.maximumInvestment
    );
  }

}
